"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { SignedIn, SignedOut } from "@clerk/nextjs";
import { Files } from "lucide-react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ProUpsellModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ProUpsellModal({ open, onOpenChange }: ProUpsellModalProps) {
  useEffect(() => {
    if (open) {
      posthog.capture("pro_upsell_shown", { trigger: "conversion_count" });
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Files className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle className="text-center">
            Converting lots of files?
          </DialogTitle>
          <DialogDescription className="text-center">
            With FitConvert Pro, you can batch convert an entire folder at once
            and download everything as a ZIP. Plans start at $2.99/mo.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <SignedOut>
            <Button className="w-full" asChild>
              <Link href="/pricing">See Pro pricing</Link>
            </Button>
          </SignedOut>
          <SignedIn>
            <Button className="w-full" asChild>
              <Link href="/pricing">View Pro plans</Link>
            </Button>
          </SignedIn>
          <Button
            variant="ghost"
            className="w-full"
            onClick={() => onOpenChange(false)}
          >
            Maybe later
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
